<template>
  <footer :class="dark ? 'bg-black t-white br-t-white-transp-10' : 'bg-white br-t-black-transp-10'" class="w-100 mobile:pd-medium tablet:pd-medium pd-extra pd-b-medium">
    <div class="desktop:pd-l-big desktop:pd-r-big">
      <div>
        <!-- Logo -->
        <img :src="dark ? '/logo/logotype-white.svg' : '/logo/logotype-black.svg'" alt="Commune" class="h-1r mn-b-big mobile:mn-t-big" />

       


        <!-- Description -->
        <p class="text w-max-20r mn-b-big ">
          Experience beachfront dining, signature cocktails, and vibrant sunsets at Commune Phuket. Where ocean views meet culinary excellence.
        </p>
        

        <!-- Social Links — скрыты 2026-10-06, список профилей и их статус в PROFILES.md -->
        <!-- <div class="flex gap-thin tablet:gap-small flex-wrap mn-b-medium">
          <a href="https://www.instagram.com/commune.phuket/" target="_blank" rel="noopener noreferrer" class="fw-medium uppercase">
            Instagram
          </a>
          <a href="https://www.facebook.com/people/The-Commune-Phuket/61554341168486/" target="_blank" rel="noopener noreferrer" class="uppercase fw-medium">
            Facebook
          </a>
        </div> -->

        <!-- Navigation Links -->
        <div :class="dark ? 'br-t-white-transp-10' : 'br-t-black-transp-10'" class="grid cols-4 tablet:cols-2 mobile:cols-1 gap-medium mobile:gap-big pd-t-semi mn-b-big mobile:mn-b-medium">
          <div>
            <h2 class="h5 uppercase mn-b-small">
              Contact
            </h2>
            <div class="flex flex-column gap-small">
              <a href="https://goo.gl/maps/9u6voKo47HTcqriB9" target="_blank" rel="noopener" class="flex flex-v-center">
                <span>10/3 Laemsai Rd, Karon, Phuket</span>
              </a>
              <a href="tel:+66932326915" class="flex flex-v-center">
                <span>+66 93 232 6915</span>
              </a>
              <!-- <a href="mailto:hello@communephuket.com" class="flex flex-v-center">
                <span>hello@communephuket.com</span>
              </a> -->
            </div>
          </div>

          <div>
            <h2 class="h5 uppercase mn-b-small">
              Hours
            </h2>
            <div class="flex flex-column gap-small">
              <p class="text">
                Daily 10:00 - 22:00
              </p>

            </div>
          </div>

          <div>
            <h2 class="h5 uppercase mn-b-small">
              About
            </h2>
            <div class="flex flex-column gap-small">
              <!-- Страница about выключена 2026-10-17 -->
              <!-- <router-link to="/about">
                Our Story
              </router-link> -->
              <!-- <router-link to="/nightlife">
                Nightlife
              </router-link> -->
              <!-- Страница меню выключена 2026-10-17 -->
              <!-- <router-link to="/menu">
                Menu
              </router-link> -->
              <router-link to="/visit-terms">
                Visit Terms
              </router-link>
              <router-link to="/privacy">
                Privacy Policy
              </router-link>
              <router-link to="/backoffice">
                Admin
              </router-link>
            </div>
          </div>

          
        </div>

        <!-- Copyright -->
        <div class="pd-t-semi tablet:pd-t-medium d-flex flex-justify-between flex-align-center mobile:flex-column mobile:flex-align-start mobile:gap-medium">
          <p class="text">
            © 2025 Commune Phuket. All rights reserved.
          </p>
          <a href="https://oz.digital" target="_blank" rel="noopener noreferrer" class="d-flex flex-align-center gap-thin" style="opacity: 0.5; text-decoration: none;">
            <span>With ❤ from</span>
            <img src="/logo/ozdao.svg" alt="OZ" style="height: 1.2em; vertical-align: middle;" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>

defineProps({
  dark: {
    type: Boolean,
    default: false
  }
})
</script>
